import React from 'react'
import { observer, inject } from 'mobx-react'
import classnames from 'classnames'
import { scaleLinear } from 'd3-scale'
import { interpolateCubehelix } from 'd3-interpolate'
import { format } from 'd3-format'
import Icon from 'components/common/Icon'
import ChartSVG from './ChartSVG'
import ChartLegend from './ChartLegend'
import { withTranslation } from 'react-i18next'

// constant margins around the chart, except use more margin
// on the left for more digits on the y axis labels
const chartMargin = analysis => ({
  top: 8,
  right: 10,
  bottom: 40,
  left: Math.max(60, 8.25 * format('.0f')(analysis.maxValue).length)
})

// Root of the SVG demographics chart. Overall approach is to
// use React to manage the DOM, but use D3 utility functions
// to make charting easier.
//
// This approach is described under "React for element creation, D3 as the
// visualization kernel" at:
// https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71
const DemographicsBarChart = ({ uiStore, analysis, seriesNames, seriesLabels, t }) => {
  const color = scaleLinear()
    .domain([0, seriesNames.length - 1])
    .range(['#2B464F', '#bbb'])
    .interpolate(interpolateCubehelix)

  return (
    <div className={classnames({
      'bar-chart': true,
      'analysis-column': true,
      'tight-spacing': true,
      fill: true,
      'analysis-empty': analysis.sum === 0
    })}
    >
      <legend
        onClick={() => uiStore.showBarChart()}
        className={classnames({
          expanded: (uiStore.isBarChartActive)
        })}
      >
        {t('POPULATION.AGE_GENDER')}
        <span title='Hide/unhide chart' style={{ paddingLeft: '5px' }} className='expand-collapse'>
          <Icon id='eye' />
        </span>
      </legend>
      {uiStore.isBarChartActive && (
        <div>
          <ChartSVG
            color={color}
            analysis={analysis}
            seriesNames={seriesNames}
            chartMargin={chartMargin(analysis)}
          />
          <ChartLegend
            analysis={analysis}
            seriesLabels={seriesLabels}
            color={color}
            chartMargin={chartMargin(analysis)}
          />
        </div>
      )}
    </div>
  )
}
export default withTranslation()(inject('uiStore')(observer(DemographicsBarChart)))
